import { Back, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { AssetUtils, RectUtils } from "html-living-framework";
import { texture } from "../core/AssetHelpers";
import {HoverableButton, TextureButton} from "../core/Button";
import { Container } from "../core/Container";
import {Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import * as PlanterGameModel from "../data/PlanterGameModel";
import {TrashType} from "../data/TrashType";
import { ColorRampFilter } from "../filters/ColorRampFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { Button } from "./Button";
import { Planter } from "./Planter";

export class CustomizedPlanter extends Planter {

    public sticker = this.visuals.addChild(new Sprite());
    protected _subscriptions: any[] = [];
    protected colorRampFilter: ColorRampFilter = new ColorRampFilter(PIXI.Texture.EMPTY);

    protected stickerRect = new PIXI.Rectangle(-50, -270, 100, 260);
    // private readonly stickerArea: PIXI.Graphics;

    public get center() {
        return RectUtils.center(this.stickerRect).x;
    }

    constructor() {
        super();
        this.name = "CustomizedPlanter";
        this._subscriptions.push(PubSub.subscribe("planter update", this.onPlanterUpdate.bind(this)));
        // this.stickerArea = this.visuals.addChildAt(new PIXI.Graphics(), 1);
        // this.stickerArea.beginFill(0x00ff00, 0.5);
        // this.stickerArea.drawRect(this.stickerRect.x, this.stickerRect.y, this.stickerRect.width, this.stickerRect.height);
        // this.stickerArea.endFill();
    }

    public destroy() {
        super.destroy();
        this._subscriptions.forEach(PubSub.unsubscribe);
    }

    public onLayout() {
        this.scale.set(1);
        this.onPlanterUpdate("planter update", PlanterGameModel.GameState);
    }

    public Plant(pPlantName: string) {
        this.plant.scale.set(1 / this.scale.y);
        super.Plant(pPlantName);
        this.plant.y = -this.sprite.height;
        this.plant.x = HLF.RectUtils.center(this.stickerRect).x;
    }

    protected onPlanterUpdate(pTopic: "planter update", pData: typeof PlanterGameModel.GameState) {
        this.sprite.setLayoutTexture(pData.shape + "-" + pData.pattern, 0.5, 1);
        this.colorRampFilter.uniforms.uRamp = texture("planterparty-" + pData.colour + "-gradientmap");
        this.sprite.filters = [this.colorRampFilter];
        switch (pData.shape) {
            case PlanterGameModel.PlanterShape.WateringCan:
                this.stickerRect.x = -30;
                break;
            case PlanterGameModel.PlanterShape.RainBoot:
                this.stickerRect.x = 0;
                break;
            default:
                this.stickerRect.x = -50;
                break;
        }

        const prevSticker = this.sticker.name;

        if (pData.sticker !== PlanterGameModel.PlanterSticker.None) {
            this.sticker.setLayoutTexture(pData.sticker + "-large", 0.5, 0.5);
            this.FitStickerToRect(this.sticker, this.stickerRect);
            if (this.sticker.name !== prevSticker || !this.sticker.visible) {
                TweenLite.from(this.sticker, 0.25, {pixi: {scale: this.sticker.scale.x * 1.15}, ease: Back.easeOut});
            }
        }
        this.sticker.visible = pData.sticker !== PlanterGameModel.PlanterSticker.None;

        // this.stickerArea.clear();
        // this.stickerArea.beginFill(0x00ff00, 0.5);
        // this.stickerArea.drawRect(this.stickerRect.x, this.stickerRect.y, this.stickerRect.width, this.stickerRect.height);
        // this.stickerArea.endFill();
    }

    protected FitStickerToRect(pSticker: Sprite, pRect: PIXI.Rectangle) {
        // reset scale
        pSticker.scale.set(1);
        // shrink width to fit
        pSticker.width = Math.min(pSticker.width, pRect.width);
        // preserve aspect ratio
        pSticker.scale.set(pSticker.scale.x);
        // shrink height to fit
        pSticker.height = Math.min(pSticker.height, pRect.height);
        // preserve aspect ratio
        pSticker.scale.set(Math.min(pSticker.scale.x, pSticker.scale.y));

        const {x, y} = RectUtils.center(pRect);
        pSticker.x = x;
        pSticker.y = y;
    }
}
